import { createSlice } from '@reduxjs/toolkit'
import { AppThunk } from '..'
import { IProgram } from './interfaces'
import moment from 'moment'

const programSlice = createSlice({
  name: 'program',
  initialState: {
    data: {} as IProgram,
    loaded: false,
    error: false,
    answeredParticipantCustomQuestions: [] as number[],
  },
  reducers: {
    setProgram(state, action) {
      state.data = action.payload
      state.loaded = true
    },
    loadingFailed(state, action) {
      state.loaded = false
      state.error = action.payload
      state.data = {} as IProgram
    },
    setAnsweredParticipantCustomQuestions(state, action) {
      state.answeredParticipantCustomQuestions = action.payload
    },
  },
})

export default programSlice.reducer
export const {
  setProgram,
  loadingFailed,
  setAnsweredParticipantCustomQuestions,
} = programSlice.actions

export const fetchProgram = (): AppThunk => async (dispatch, getState) => {
  console.log('Fetching program...')
  try {
    const { baseUrl, programId } = getState().misc
    const normal = await fetch(`${baseUrl}/api/programs/${programId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    const extended = await fetch(
      `${baseUrl}/api/programs/${programId}/extended`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    const allData = {
      ...(await normal.json()),
      ...(await extended.json()),
    }
    allData.hide_event_occupation =
      moment(allData.last_registration_date) < moment() &&
      allData.hide_booking_after_program_end
    return dispatch(setProgram(allData))
  } catch (error: unknown) {
    if (error instanceof Error) {
      return dispatch(loadingFailed(error.toString()))
    } else if (typeof error === "string") {
      return dispatch(loadingFailed(error))
    }
  }
}
